import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

// DotLegalCheckbox resets MUI's -11px label margin, which leaves the box indented by its own padding.
// Giving the margin back lines the box up with the heading above it.
export const catalogCheckboxMargin = { marginLeft: -1.375 };

export const useCatalogPaneStyles = () => {
    const theme = useTheme();
    const chooseAllLink = {
        fontSize: theme.typography.pxToRem(12),
        color: theme.palette.primary.main,
        textDecoration: "underline",
        "&:hover": {
            cursor: "pointer",
        },
    };

    return createSxStyles({
        // The pane's fixed content clips its overflow, so the pills' shadow needs room inside it
        filters: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
            paddingBottom: theme.spacing(1),
        },
        chooseAllLink,
        chooseAll: {
            ...chooseAllLink,
            display: "flex",
            justifyContent: "flex-end",
            position: "absolute",
            right: 0,
            top: 0,
            paddingTop: 1,
        },
        group: {
            marginBottom: theme.spacing(2),
        },
        // Columns follow the pane's own width, which the user can resize, so a viewport breakpoint would not fit
        templates: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
            columnGap: theme.spacing(2),
        },
        template: {
            display: "flex",
            alignItems: "center",
        },
    });
};
